var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterOnlyGray(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "63px",
    viewBox: "0 0 60 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "filterOnlyGray") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.0949799,42.9901277 C21.3398224,50.2192636 32.962734,50.551065 40.6081585,43.7470044 L57.3437813,60.4833877 C57.7751755,60.9131558 59.0572812,61.5278037 60.4513385,60.4833877 C61.8453959,59.4389718 60.8810909,57.5067859 60.4513385,57.0753761 L43.7157378,40.3390258 C48.7150452,33.6285398 48.4223555,21.9692151 40.8789366,15.1615709 C33.3355177,8.35392671 21.1340014,8.35392671 13.8360575,15.9364974 C6.53811357,23.5190682 6.65324507,35.5486354 14.0949799,42.9901277 Z M33.8774446,14.5449262 C39.8576549,17.0220726 43.7568605,22.8578209 43.7568605,29.3309595 C43.7568605,35.804098 39.8576549,41.6398463 33.8774446,44.1169928 C27.8972344,46.5941392 21.0137257,45.2248496 16.4367013,40.6476243 C13.4231343,37.6528001 11.7285389,33.5796203 11.7285427,29.3309552 C11.7285466,25.08229 13.4231495,21.0091133 16.436722,18.0142946 C21.0137257,13.4370693 27.8972344,12.0677797 33.8774446,14.5449262 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.12,46.535 C60.12,47.515305 60.8501078,48.31 61.7606485,48.31 L75.5193515,48.31 C76.4254569,48.31 77.16,47.5221396 77.16,46.535 C77.16,45.554695 76.4298922,44.76 75.5193515,44.76 L61.7606485,44.76 C60.8545431,44.76 60.12,45.5478604 60.12,46.535 Z M45.92,56.83 C45.92,57.810305 46.6922294,58.605 47.6553013,58.605 L75.4246987,58.605 C76.3830794,58.605 77.16,57.8171396 77.16,56.83 C77.16,55.849695 76.3877706,55.055 75.4246987,55.055 L47.6553013,55.055 C46.6969206,55.055 45.92,55.8428604 45.92,56.83 Z M36.3551074,67.125 C36.3551074,68.105305 37.0330401,68.9 38.34632,68.9 L75.2050732,68.9 C76.511956,68.9 77.2310693,68.1121396 77.2310693,67.125 C77.2310693,66.144695 76.5183531,65.35 75.2050732,65.35 L38.34632,65.35 C37.0394371,65.35 36.3551074,66.1378604 36.3551074,67.125 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filterOnlyGray",
    transform: "translate(-18.000000, -7.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask-Copy",
    fill: "#333333",
    fillRule: "nonzero",
    transform: "translate(34.807569, 35.603630) scale(-1, -1) rotate(-115.000000) translate(-34.807569, -35.603630) ",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#333333",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterOnlyGray);
export default __webpack_public_path__ + "static/media/filterOnlyGray.33048c0ac8401a968eaf62defef87d85.svg";
export { ForwardRef as ReactComponent };